import { makeAutoObservable } from "mobx";
import { InternalParameterSet, ParameterSet, ScheduleParameterSet, } from "../ParameterSet";
export class PurchaseOrderScope {
    constructor(params) {
        this.restaurant = params.restaurant;
        this.salesChannel = params.salesChannel;
        this.fulfillmentInstructions = params.fulfillmentInstructions;
        this.now = params.now;
        makeAutoObservable(this);
    }
    get parameterSet() {
        return new ParameterSet({
            schedule: this.fulfillmentTime === null
                ? ScheduleParameterSet.empty()
                : ScheduleParameterSet.matchingFulfillmentTime(this.restaurant.menu.schedules, this.fulfillmentTime),
            internal: new InternalParameterSet({
                orderOrigin: this.salesChannel.menuOrderOrigin,
                fulfillmentMethod: this.fulfillmentInstructions.fulfillmentMethod,
                splitToHalves: null,
            }),
        });
    }
    get fulfillmentTime() {
        const fulfillmentTime = this.fulfillmentInstructions.fulfillmentTime;
        if (fulfillmentTime === null) {
            return null;
        }
        switch (fulfillmentTime.type) {
            case "ASAP":
                return this.now;
            case "OnTime":
                return fulfillmentTime.date;
        }
    }
}
